var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"rc-button",class:[
    _vm.btnClass,
    _vm.type ? ("rc-button--" + _vm.type) :'',
    _vm.size ?("rc-button--" + _vm.size):''
  ],attrs:{"disabled":_vm.buttonDisabled,"type":_vm.nativeType},on:{"click":_vm.onClick}},[(_vm.loading)?_c('rc-loading',{attrs:{"color":_vm.type === 'default' || _vm.plain ? 'black' : 'white',"type":"spinner","size":"15px"}}):_vm._e(),(_vm.icon && !_vm.loading)?_c('i',{class:_vm.icon}):_vm._e(),_c('span',{staticClass:"rc-button__text"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }